import { WORD_EXEC } from "@Utils/doc/wordExec";
import { clientToolRegistry } from "./clientToolRegistry";
import { executeWordExec } from "./wordExec";
const wordExec = {
    mutatesDocument: true,
    execute: executeWordExec
};
export function registerOfficeToolHandlers() {
    clientToolRegistry[WORD_EXEC] = wordExec;
}
